const jwt_claims = {
    title: 'JWT سفارشی',
    description: 'توکن دسترسی یا توکن شناسایی را سفارشی کنید و اطلاعات اضافی به برنامه خود ارائه دهید.',
    access_token: {
        card_title: 'توکن دسترسی',
        card_description: 'توکن دسترسی اعتبارنامه‌ای است که APIها برای مجاز کردن درخواست‌ها استفاده می‌کنند و فقط شامل ادعاهای لازم برای تصمیم‌گیری دسترسی است.',
    },
    user_jwt: {
        card_field: 'توکن دسترسی کاربر',
        card_description: 'داده‌های مختص کاربر را هنگام صدور توکن دسترسی اضافه کنید.',
        for: 'برای کاربر',
    },
    machine_to_machine_jwt: {
        card_field: 'توکن دسترسی ماشین به ماشین',
        card_description: 'داده‌های اضافی را هنگام صدور توکن ماشین به ماشین اضافه کنید.',
        for: 'برای M2M',
    },
    id_token: {
        card_title: 'توکن شناسایی',
        card_description: 'توکن شناسایی تأیید هویتی است که پس از ورود دریافت می‌شود و شامل ادعاهای هویت کاربر برای نمایش یا ایجاد نشست توسط کلاینت است.',
        card_field: 'توکن شناسایی کاربر',
        card_field_description: "ادعاهای 'sub'، 'email'، 'phone'، 'profile' و 'address' همیشه در دسترس هستند. سایر ادعاها باید ابتدا در اینجا فعال شوند. در هر صورت، برنامه شما باید scopeهای متناظر را هنگام یکپارچه‌سازی درخواست کند تا آن‌ها را دریافت کند.",
    },
    code_editor_title: 'سفارشی‌سازی ادعاهای {{token}}',
    custom_jwt_create_button: 'افزودن ادعاهای سفارشی',
    custom_jwt_item: 'ادعاهای سفارشی {{for}}',
    delete_modal_title: 'حذف ادعاهای سفارشی',
    delete_modal_content: 'آیا مطمئن هستید که می‌خواهید ادعاهای سفارشی را حذف کنید؟',
    clear: 'شروع از نو',
    cleared: 'پاک شد',
    restore: 'بازیابی پیش‌فرض‌ها',
    restored: 'بازیابی شد',
    data_source_tab: 'منبع داده',
    error_handling_tab: 'مدیریت خطا',
    test_tab: 'زمینه آزمایش',
    jwt_claims_description: 'ادعاهای پیش‌فرض به‌صورت خودکار در توکن گنجانده می‌شوند و قابل بازنویسی نیستند.',
    user_data: {
        title: 'زمینه کاربر',
        subtitle: 'از پارامتر ورودی `context.user` برای ارائه اطلاعات حیاتی کاربر استفاده کنید.',
    },
    grant_data: {
        title: 'زمینه grant',
        subtitle: 'از پارامتر ورودی `context.grant` برای ارائه اطلاعات حیاتی grant استفاده کنید؛ فقط برای تبادل توکن در دسترس است.',
    },
    interaction_data: {
        title: 'زمینه تعامل کاربر',
        subtitle: 'از پارامتر `context.interaction` برای دسترسی به جزئیات تعامل کاربر در نشست احراز هویت فعلی استفاده کنید.',
    },
    application_data: {
        title: 'زمینه برنامه',
        subtitle: 'از پارامتر ورودی `context.application` برای ارائه اطلاعات برنامه مرتبط با توکن استفاده کنید.',
    },
    token_data: {
        title: 'بار توکن',
        subtitle: 'از پارامتر ورودی `token` برای بار فعلی توکن دسترسی استفاده کنید.',
    },
    api_context: {
        title: 'زمینه API: کنترل دسترسی',
        subtitle: 'از متد `api.denyAccess` برای رد درخواست توکن استفاده کنید.',
    },
    error_handling: {
        title: 'مدیریت خطا',
        subtitle: 'کنترل کنید که آیا صدور توکن هنگام خطای اسکریپت باید مسدود شود.',
        input_field_title: 'رفتار صدور توکن در صورت خطای اسکریپت',
        block_issuance_switch: 'مسدود کردن صدور توکن هنگام خطای اسکریپت',
        default_hint_create: 'اسکریپت‌های ادعای سفارشی جدید به‌صورت پیش‌فرض صدور توکن را هنگام خطای اسکریپت مسدود می‌کنند. اگر API از قبل مقداری ارائه داده باشد، مقدار ذخیره‌شده استفاده می‌شود.',
        default_hint_edit: 'اسکریپت‌های ادعای سفارشی موجود بدون این تنظیم، تا زمانی که صریحاً مقداری ذخیره نکنید، پیش‌فرض قدیمی (غیرفعال) را حفظ می‌کنند.',
        warning: 'وقتی فعال باشد، خطاهای زمان اجرای اسکریپت درخواست توکن را با `invalid_request` (400) و `error_description` بومی‌سازی‌شده رد می‌کنند. فراخوانی‌های `api.denyAccess` همچنان `access_denied` برمی‌گردانند.',
    },
    fetch_external_data: {
        title: 'دریافت داده خارجی',
        subtitle: 'داده‌های APIهای خارجی خود را مستقیماً در ادعاها بگنجانید.',
        description: 'از تابع `fetch` برای فراخوانی APIهای خارجی و گنجاندن داده در ادعاهای سفارشی استفاده کنید. مثال: ',
    },
    environment_variables: {
        title: 'تنظیم متغیرهای محیطی',
        subtitle: 'از متغیرهای محیطی برای ذخیره اطلاعات حساس استفاده کنید.',
        input_field_title: 'افزودن متغیرهای محیطی',
        sample_code: 'دسترسی به متغیرهای محیطی در handler ادعاهای توکن سفارشی. مثال: ',
    },
    jwt_claims_hint: 'ادعاهای سفارشی را زیر ۵۰ کیلوبایت نگه دارید. ادعاهای پیش‌فرض توکن به‌صورت خودکار در توکن گنجانده می‌شوند و قابل بازنویسی نیستند.',
    tester: {
        subtitle: 'توکن و داده کاربر آزمایشی را برای تست تنظیم کنید.',
        run_button: 'اجرای آزمایش',
        result_title: 'نتیجه آزمایش',
    },
    form_error: {
        invalid_json: 'قالب JSON نامعتبر است',
    },
};
export default Object.freeze(jwt_claims);
